import { MessageBox } from 'element-ui'
import './style.scss'

const YMessageBox = MessageBox

export default YMessageBox
